import BonusXIcon from '@/images/frontend/icons/bonusx.webp';
import AptusIcon from '@/images/icons/aptus.svg?url';
import BuzzoleIcon from '@/images/icons/buzzoole_color.svg?url';
import CosmicoIconDark from '@/images/icons/cosmico_dark.svg?url';
import SpinupIcon from '@/images/icons/spinup.svg?url';
import WeeboraColorIcon from '@/images/icons/weebora_color.svg?url';

export const cardsData = [
	{ image: WeeboraColorIcon, name: 'Weebora' },
	{ image: AptusIcon, name: 'Aptus' },
	{ image: BuzzoleIcon, name: 'Buzzole' },
	{ image: BonusXIcon, name: 'Bonus X' },
	{ image: SpinupIcon, name: 'SpinUp' },
	{ image: CosmicoIconDark, name: 'Cosmico' },
];
